import { SUPER_GROUP_ID } from 'config';
export function pickGroup(subject) {
    const defaultGroup = {
        id: 'group_id',
        name: 'Business user',
        type: 'temporary_type',
    };
    const groupMap = subject.principal?.group;
    if (!groupMap || Object.keys(groupMap).length === 0) {
        return defaultGroup;
    }
    if (groupMap[SUPER_GROUP_ID]) {
        return groupMap[SUPER_GROUP_ID];
    }
    return Object.values(groupMap).sort((a, b) => {
        const aIndirection = a.indirection || 0;
        const bIndirection = b.indirection || 0;
        if (aIndirection !== bIndirection) {
            return aIndirection - bIndirection;
        }
        return a.id.localeCompare(b.id);
    })[0];
}
